<template>
  <div class="page-online-stat">
    <template v-if="widgetVisible">
      <el-popover
        v-model="visible"
        placement="top-end"
        width="280"
        trigger="click"
        popper-class="page-online-stat-popper"
      >
        <div class="page-online-stat__title">
          当前页面在线人员（<span class="page-online-stat__count-text">{{ currentUsers.length }}</span>）
        </div>
        <div v-if="currentUsers.length === 0" class="page-online-stat__empty">
          暂无其他人在此页面
        </div>
        <ul v-else class="page-online-stat__list">
          <li v-for="user in currentUsers" :key="user.id" class="page-online-stat__item">
            <el-avatar :size="32" :src="user.avatar || ''">
              <span>{{ (user.nickname || '?').charAt(0) }}</span>
            </el-avatar>
            <span class="page-online-stat__name">{{ user.nickname || '未知' }}</span>
          </li>
        </ul>

        <div slot="reference" class="page-online-stat__trigger" @click="refreshCount">
          <template v-if="currentUsers.length">
            <span class="page-online-stat__avatars">
              <span
                v-for="(user, i) in showUsers"
                :key="user.id"
                class="page-online-stat__avatar"
                :style="{
                  zIndex: showUsers.length - i,
                  marginLeft: i > 0 ? -1 * (avatarSize / 2) + 'px' : 0
                }"
              >
                <img
                  v-if="user.avatar"
                  class="page-online-stat__img"
                  :src="user.avatar"
                  :alt="user.nickname || ''"
                >
                <span v-else class="page-online-stat__letter">{{ (user.nickname || '?').charAt(0) }}</span>
              </span>
              <span v-if="currentCount > showUsers.length" class="page-online-stat__more">
                +{{ currentCount - showUsers.length }}
              </span>
              <span class="page-online-stat__num">{{ currentCount }}</span>
            </span>
          </template>
          <i v-else class="el-icon-user" />
          <span class="page-online-stat__tip">在线</span>
        </div>
      </el-popover>
      <button
        type="button"
        class="page-online-stat__close"
        title="关闭（1 天内不再显示）"
        @click.stop="closeWidget"
      >×</button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PageOnlineStat',
  data() {
    return {
      visible: false,
      // 是否显示小部件（关闭后 1 天内不再显示）
      widgetVisible: true,
      // 关闭后隐藏时长：1 天
      hideDuration: 24 * 60 * 60 * 1000,
      // localStorage 记录关闭时间的键名
      closeKey: 'page_online_stat_closed_at',
      // path => [user,...]，服务端推送/拉取的各页面在线用户
      usersByPath: {},
      pollTimer: null,
      // 轮询周期：15秒
      pollInterval: 15 * 1000,
      // 头像叠加展示：头像尺寸（px）
      avatarSize: 28,
      // 头像叠加展示：最多展示的头像数量
      maxAvatars: 5
    }
  },
  computed: {
    currentPath() {
      return this.$route ? this.$route.path : ''
    },
    currentUsers() {
      return this.usersByPath[this.currentPath] || []
    },
    currentCount() {
      return this.currentUsers.length
    },
    // 叠加展示用：截取前 maxAvatars 个用户
    showUsers() {
      return this.currentUsers.slice(0, this.maxAvatars)
    }
  },
  watch: {
    currentPath(val, old) {
      // 页面切换时上报并拉取最新在线用户
      if (val && val !== old) this.reportPage()
    }
  },
  mounted() {
    // 关闭后 1 天内不再显示
    let closedAt = 0
    try {
      closedAt = Number(localStorage.getItem(this.closeKey)) || 0
    } catch (e) {
      closedAt = 0
    }
    if (closedAt && Date.now() - closedAt < this.hideDuration) {
      this.widgetVisible = false
      return
    }
    // 订阅「页面在线人数」通知
    this.subscribe()
    this.bindWsEvents()
    // 首次上报并拉取
    this.reportPage()
    // 定时上报 + 刷新（同时兼容 WS 断线重连后的重新注册）
    this.pollTimer = setInterval(() => this.reportPage(), this.pollInterval)
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer)
      this.pollTimer = null
    }
    this.unbindWsEvents()
    // 取消订阅「页面在线人数」通知
    if (this.$globalWs && this.$globalWs.subEvt)
      this.$globalWs.subEvt('cancel_subscribe_page_users')
  },
  methods: {
    subscribe() {
      if (this.$globalWs && this.$globalWs.subEvt)
        this.$globalWs.subEvt('subscribe_page_users')
    },
    bindWsEvents() {
      if (this.$globalWs && this.$globalWs.onEvt)
        this.$globalWs.onEvt('ev_page_users', (msg, data) => {
          if (msg === 'success' && data && data.path) {
            this.$set(this.usersByPath, data.path, data.users || [])
          }
        })
    },
    unbindWsEvents() {
      if (this.$globalWs && this.$globalWs.rmEvt)
        this.$globalWs.rmEvt('ev_page_users')
    },
    reportPage() {
      if (!this.$globalWs || !this.$globalWs.sendMsg) return
      // 上报当前页面，让服务端登记「我在本页」
      this.$globalWs.sendMsg({ event: 'update_page', data: { path: this.currentPath } })
      // 拉取当前页面的在线用户列表
      this.$globalWs.sendMsg({ event: 'get_page_users', data: { path: this.currentPath } })
    },
    refreshCount() {
      // 点击时主动刷新一次
      if (this.$globalWs && this.$globalWs.sendMsg)
        this.$globalWs.sendMsg({ event: 'get_page_users', data: { path: this.currentPath } })
    },
    // 关闭小部件，记录关闭时间，1 天内不再显示
    closeWidget() {
      this.widgetVisible = false
      try {
        localStorage.setItem(this.closeKey, String(Date.now()))
      } catch (e) {
        // 忽略存储失败
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-online-stat {
  position: fixed;
  right: 24px;
  bottom: 124px;
  z-index: 3000;

  &__trigger {
    display: flex;
    align-items: center;
    padding: 8px 14px;
    background: #ffffff;
    border: 1px solid #ff3176;
    border-radius: 22px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
    cursor: pointer;
    font-size: 13px;
    color: #ff3176;
    user-select: none;
    opacity: 0.1;
    transition: box-shadow 0.2s, opacity 0.2s;

    &:hover {
      box-shadow: 0 4px 16px rgba(255, 49, 118, 0.25);
      opacity: 1;
    }

    .el-icon-user {
      font-size: 16px;
      margin-right: 4px;
    }
  }

  &__close {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    line-height: 16px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: #ff3176;
    color: #fff;
    font-size: 13px;
    text-align: center;
    cursor: pointer;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
    opacity: 0;
    transition: opacity 0.2s, background 0.2s;

    &:hover {
      background: #d92b65;
    }
  }

  &:hover &__close {
    opacity: 1;
  }

  &__avatars {
    display: inline-flex;
    align-items: center;
    margin-right: 6px;
  }

  &__avatar {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    border-radius: 50%;
    border: 2px solid #ffffff;
    background: #f5f5f5;
    overflow: hidden;
    box-sizing: border-box;
    box-shadow: 0 0 0 1px rgba(255, 49, 118, 0.2);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  &__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  &__letter {
    width: 100%;
    height: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #ffffff;
    background: #ff3176;
  }

  &__more {
    font-size: 13px;
    font-weight: 600;
    color: #ff3176;
    margin-left: 2px;
  }

  &__num {
    font-weight: 700;
    font-size: 16px;
    min-width: 16px;
    text-align: center;
    margin-left: 2px;
  }

  &__tip {
    margin-left: 4px;
    color: #909399;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  &__count-text {
    color: #ff3176;
  }

  &__empty {
    color: #909399;
    text-align: center;
    padding: 12px 0;
    font-size: 13px;
  }

  &__list {
    max-height: 260px;
    overflow-y: auto;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  &__item {
    display: flex;
    align-items: center;
    padding: 6px 4px;

    & + & {
      border-top: 1px solid #f0f0f0;
    }
  }

  &__name {
    margin-left: 10px;
    font-size: 13px;
    color: #303133;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
